import { Navigate, useLocation } from "react-router-dom";
import StatusMessage from "../components/cognito/StatusMessage";
import AuthLayout from "../layouts/AuthLayout";

const AuthFeedback = () => {
  const location = useLocation();
  const { title, message, type } = location.state || {};

  // Reached directly (refresh/bookmark) there is no feedback to show — go back to login.
  if (!message) return <Navigate to="/login" replace />;

  return (
    <AuthLayout title={title}>
      <StatusMessage type={type} message={message} />
    </AuthLayout>
  );
};

export default AuthFeedback;
